import React from 'react';
import { connect } from 'react-redux';
import { Box, Divider } from '@drone-js/core';
import { useInView } from 'react-intersection-observer';
import { mapStateToProps, OfferCardContainerProps } from 'component/page/detail/PackageOptions/ExpandedOffer/OfferCardContainer/OfferCardContainer.selectors';
import OfferCardPaxPanel from 'component/page/detail/PackageOptions/ExpandedOffer/OfferCardPaxPanel/OfferCardPaxPanel';
import OfferOptions from 'component/page/detail/PackageOptions/ExpandedOffer/OfferOptions/OfferOptions';
import OfferCardDateSelection from 'component/page/detail/PackageOptions/ExpandedOffer/OfferCardDateSelection/OfferCardDateSelection';
import OfferCardFooter from 'component/page/detail/PackageOptions/ExpandedOffer/OfferCardBookButtonSection/OfferCardFooter';
import { OfferCardFooterType } from 'component/page/detail/PackageOptions/ExpandedOffer/OfferCardBookButtonSection/OfferCardFooter.selectors';
import { getLocationWithOfferQueryString } from 'core/utils/offerOptionParameters';
import { replaceState } from 'core-framework/window/history';
import { useLocation } from 'react-router-dom';
import { FeatureName } from 'core/constant/FeatureName';
import { isOn } from 'core/window/bootstrapConfig';
import { FloatingPanelContext } from 'component/page/detail/FloatingSidePanel/FloatingPanelContext';
import { usePackageOptionsModularContext } from 'component/page/detail/PackageOptions/PackageOptionsModularContext';

const OfferCardContainer: React.FC<OfferCardContainerProps> = React.memo((props) => {
    const { setFloatingPanelVisible } = React.useContext(FloatingPanelContext);
    const { isHideOfferCalendar } = usePackageOptionsModularContext();
    const { ref, inView } = useInView({
        rootMargin: '-20% 0px -10% 0px',
        threshold: 0,
    });

    React.useEffect(() => {
        setFloatingPanelVisible(!inView);
    }, [inView, setFloatingPanelVisible]);

    const locationSearch = useLocation().search;

    React.useEffect(() => {
        if (
            // Allow 0 values for offerOptionId
            isOn(FeatureName.MaintainSelectedOfferOnDetails) &&
            props.offerId &&
            props.paxState &&
            props.offerOptionId !== undefined &&
            props.offerLevelSelectedDate
        ) {
            const offerQueryString = getLocationWithOfferQueryString(locationSearch, props.offerId, props.paxState, props.offerOptionId, props.offerLevelSelectedDate);
            replaceState(`?${offerQueryString}`);
        }
    }, [props.offerId, props.paxState, locationSearch, props.offerOptionId, props.offerLevelSelectedDate]);

    return (
        <div data-testid="booking-options">
            <Divider my="16" color="base.default" />
            <Box display="flex" flexDirection={props.screenSize.tabletOrDesktop ? 'row' : 'column'}>
                {!isHideOfferCalendar && <OfferCardDateSelection />}
                <Box aria-live="polite" display="flex" flexDirection="column" justifyContent="space-between" width="100%">
                    <div>
                        <OfferOptions isDisplayWarning={props.isDisplayWarning} setIsDisplayWarning={props.setIsDisplayWarning} />
                        <OfferCardPaxPanel inProgress={props.isLoading} />
                    </div>
                    <Box ref={ref} mt="24">
                        {props.screenSize.desktop && <OfferCardFooter footerType={OfferCardFooterType.Boxed} offerIndex={props.offerIndex} />}
                    </Box>
                </Box>
            </Box>
        </div>
    );
});
OfferCardContainer.displayName = 'OfferCardContainer';

export default connect(mapStateToProps)(OfferCardContainer);
